<template>
	<div
		class="widthFull relative whiteBg--repeat min-height-calc--footer"
		id="registration"
	>

		<div
			v-if="authStatus != 'success'"
			class="container-fluid"
		>
			<div class="row pb-0 center">
				<div class="col-12 pt-2">
					<h3 class="  Bold py-2 color-2 pt-5">
						Registrati </h3>
				</div>
			</div>
		</div>

		<div class="container-fluid pb-5">
			<loading v-if="loadingState" />

			<form
				v-if="authStatus != 'success'"
				class="pt-0 pb-3 pt-3"
				id="registration-form"
				@submit.prevent="registration"
			>
				<div
					v-show="adult2"
					class="form-row justify-content-center"
				>
					<div class="col-md-4 col-lg-3 mb-4 mb-md-3">
						<div class="group">
							<input
								type="text"
								class="form-control"
								v-model="first_name_player"
								id="first_name_player"
								name="first_name_player"
								data-vv-as="Nome"
								v-validate="{ required: true, max: 128, min: 2 }"
								:class="{
                  'is-invalid': errors.has('first_name_player'),
                  valid: !!first_name_player,
                }"
							/>
							<span class="highlight"></span>

							<label
								class="niceInputLabel"
								for="first_name_player"
							>Nome
							</label>
							<div
								v-if="errors.has('first_name_player')"
								class="invalid-feedback"
							>
								{{ errors.first("first_name_player") }}
							</div>
						</div>
					</div>

					<div class="col-md-4 col-lg-3 mb-4 mb-md-3">
						<div class="group">
							<input
								type="text"
								class="form-control"
								v-model="last_name_player"
								id="last_name_player"
								name="last_name_player"
								data-vv-as="Cognome"
								v-validate="{ required: true, max: 128, min: 2 }"
								:class="{
                  'is-invalid': errors.has('last_name_player'),
                  valid: !!last_name_player,
                }"
							/>
							<span class="highlight"></span>

							<label
								class="niceInputLabel"
								for="last_name_player"
							>Cognome</label>

							<div
								v-if="errors.has('last_name_player')"
								class="invalid-feedback"
							>
								{{ errors.first("last_name_player") }}
							</div>
						</div>
					</div>

					<div class="col-md-4 col-lg-2 mb-4 mb-md-3">
						<div class="group">
							<input
								type="text"
								class="form-control"
								v-model="phone_player"
								@blur="checkIfExistPhone"
								id="phone_player"
								name="phone_player"
								data-vv-as="Cellulare"
								v-validate="{ required: true, max: 11, min: 8, regex: /^[3]+/ }"
								:class="{
                  'is-invalid': errors.has('phone_player'),
                  valid: !!phone_player,
                }"
							/>
							<span class="highlight"></span>

							<label
								class="niceInputLabel"
								for="phone_player"
							>Cellulare*</label>
							<div
								v-if="existPhone"
								class="invalid-feedback"
								style="display: block"
							>
								<span>Numero di telefono già presente</span>
							</div> <b>* <a
									@click="showPopUp"
									class="underline"
								>Note</a></b>

							<div
								v-if="errors.has('phone_player')"
								class="invalid-feedback"
							>
								{{ errors.first("phone_player") }}
							</div>
						</div>
					</div>
				</div>

				<div
					v-show="adult2"
					class="form-row justify-content-center"
				>
					<div class="col-md-6 col-lg-4 mb-4 mb-md-3">
						<div class="group">
							<input
								type="text"
								v-model="username_player"
								class="form-control"
								id="username_player"
								name="username_player"
								@blur="checkIfExistEmail"
								ref="username_player"
								data-vv-as="username_player"
								v-validate="{
                  required: true,
                  email: true,
                  temporaryEmail: true,
                  plusIssueEmail: true,
                  max: 56,
                }"
								:class="{
                  'is-invalid': errors.has('username_player') || existEmail,
                  valid: !!username_player,
                }"
							/>
							<span class="highlight"></span>

							<label
								class="niceInputLabel"
								for="username_player"
							>Indirizzo E-Mail</label>

							<div
								v-if="existEmail"
								class="invalid-feedback"
								style="display: block"
							>
								<span v-if="existEmailSocial">Email digitato già presente. Sei registrato con:
									<strong class="text-capitalize">{{
                    existEmailSocial
                  }}</strong></span>
								<span v-else>Email digitato già presente</span>
							</div>
							<div
								v-if="errors.has('username_player')"
								class="invalid-feedback"
							>
								{{ errors.first("username_player") }}
							</div>
						</div>
					</div>

					<div class="col-md-6 col-lg-4 mb-4 mb-md-3">
						<div class="group">
							<input
								autocomplete="on"
								type="text"
								class="form-control"
								v-model="confirm_username"
								id="confirm_username"
								name="confirm_username"
								data-vv-as="Conferma Password"
								v-validate="{
                  required: true,
                  email: true,
                  temporaryEmail: true,
                  plusIssueEmail: true,
                  max: 56,
                  confirmed: username_player,
                }"
								:class="{
                  'is-invalid': errors.has('confirm_username'),
                  valid: !!confirm_username,
                }"
							/>
							<span class="highlight"></span>

							<label
								class="niceInputLabel"
								for="confirm_username"
							>Ripeti Indirizzo E-Mail</label>
							<div
								v-if="errors.has('confirm_username')"
								class="invalid-feedback"
							>
								{{ errors.first("confirm_username") }}
							</div>
						</div>
					</div>

				</div>

				<div
					v-show="adult2"
					class="form-row justify-content-center"
				>
					<div class="col-md-6 col-lg-4 mb-4 mb-md-3">
						<div class="group">
							<input
								autocomplete="on"
								type="password"
								class="form-control"
								v-model="password_player"
								id="password_player"
								name="password_player"
								data-vv-as="password_player"
								v-validate="{
                  required: true,
                  passwordCheck: true,
                  min: 8,
                  max: 56,
                }"
								:class="{
                  'is-invalid': errors.has('password_player'),
                  valid: !!password_player,
                }"
							/>
							<span class="highlight"></span>

							<label
								class="niceInputLabel"
								for="password_player"
							>Password</label>
							<div
								v-if="errors.has('password_player')"
								class="invalid-feedback"
							>
								{{ errors.first("password_player") }}
							</div>
						</div>
					</div>
					<div class="col-md-6 col-lg-4 mb-4 mb-md-3">
						<div class="group">
							<input
								autocomplete="on"
								type="password"
								class="form-control"
								v-model="confirm_password"
								id="confirm_password"
								name="confirm_password"
								data-vv-as="Conferma Password"
								v-validate="{
                  required: true,
                  passwordCheck: true,
                  min: 8,
                  max: 56,
                  confirmed: password_player,
                }"
								:class="{
                  'is-invalid': errors.has('confirm_password'),
                  valid: !!confirm_password,
                }"
							/>
							<span class="highlight"></span>

							<label
								class="niceInputLabel"
								for="confirm_password"
							>Ripeti Password</label>
							<div
								v-if="errors.has('confirm_password')"
								class="invalid-feedback"
							>
								{{ errors.first("confirm_password") }}
							</div>
						</div>
					</div>
				</div>

				<div class="row justify-content-center py-4">
					<div
						class="col-md-8 center badge badge-danger"
						v-if="authStatus == 'error'"
					>
						Errore conessione
					</div>

					<div class="col-md-8 mb-3">
						Presa visione dell’Informativa privacy , autorizzo/non autorizzo, barrando di seguito la casella
						corrispondente, la Società al trattamento dei miei seguenti dati personali:
					</div>

					<div class="col-md-8">
						- Dati anagrafici e di contatto per la finalità di marketing di cui al punto 3.b) dell’informativa
						<div class="form-check my-3 my-md-0">
							<div class="d-flex align-items-center">

								<div class="mr-5">
									<input
										v-model="agreement1_player"
										class="mt-3 mr-3 "
										type="radio"
										name="agreement1_player"
										id="pr1"
										value="1"
										v-validate="'required|included:0,1'"
										:class="{
                              'is-invalid': errors.has('agreement1_player'),
                            }"
									/>

									<label
										for="pr1"
										class="custom-pos-label"
									>
										<div class="">
											<span class="uppercase">Autorizzo</span>
										</div>
									</label>
								</div>

								<div class="ml-3">
									<input
										v-model="agreement1_player"
										class="mt-3 mr-3 "
										type="radio"
										name="agreement1_player"
										id="pr2"
										value="0"
										v-validate="'required|included:0,1'"
									/>

									<label
										for="pr2"
										class="custom-pos-label"
									>
										<div class="">
											<span class="uppercase">Non Autorizzo</span>
										</div>
									</label>
								</div>
							</div>
							<label
								class="red"
								v-show="errors.has('agreement1_player')"
							>
								Consenso per finalità di marketing va accettato oppure rifiutato
							</label>
						</div>
					</div>
					<div class="col-md-8">
						- Dati anagrafici e di contatto e Altri dati personali per la finalità di marketing profilato di cui al punto 3.c) dell’informativa:
						<div class="form-check my-3 my-md-0">
							<div class="d-flex align-items-center">

								<div class="mr-5">
									<input
										v-model="agreement2_player"
										class="mt-3 mr-3 "
										type="radio"
										name="agreement2_player"
										id="pr3"
										value="1"
										v-validate="'required|included:0,1'"
										:class="{
                              'is-invalid': errors.has('agreement2_player'),
                            }"
									/>

									<label
										for="pr3"
										class="custom-pos-label"
									>
										<div class="">
											<span class="uppercase">Autorizzo</span>
										</div>
									</label>
								</div>

								<div class="ml-3">
									<input
										v-model="agreement2_player"
										class="mt-3 mr-3 "
										type="radio"
										name="agreement2_player"
										id="pr4"
										value="0"
										v-validate="'required|included:0,1'"
									/>

									<label
										for="pr4"
										class="custom-pos-label"
									>
										<div class="">
											<span class="uppercase">Non Autorizzo</span>
										</div>
									</label>
								</div>
							</div>
							<label
								class="red"
								v-show="errors.has('agreement2_player')"
							>
								Consenso per finalità di marketing va accettato oppure rifiutato
							</label>
						</div>
					</div>

					<div class="col-md-8">
						- Dati anagrafici e di contatto per comunicazione ad altre società del Gruppo Heineken N.V., come indicato al punto 3.d) dell’informativa, che li potranno utilizzare per effettuare nei Suoi confronti attività promozionale con le modalità automatizzate di cui all´art. 130, comma 1 e 2, D.lgs. 101/2018 senza dover acquisire nuovamente il mio consenso.
						<div class="form-check my-3 my-md-0">
							<div class="d-flex align-items-center">

								<div class="mr-5">
									<input
										v-model="agreement3_player"
										class="mt-3 mr-3 "
										type="radio"
										name="agreement3_player"
										id="pr5"
										value="1"
										v-validate="'required|included:0,1'"
										:class="{
                              'is-invalid': errors.has('agreement3_player'),
                            }"
									/>

									<label
										for="pr5"
										class="custom-pos-label"
									>
										<div class="">
											<span class="uppercase">Autorizzo</span>
										</div>
									</label>
								</div>

								<div class="ml-3">
									<input
										v-model="agreement3_player"
										class="mt-3 mr-3 "
										type="radio"
										name="agreement3_player"
										id="pr6"
										value="0"
										v-validate="'required|included:0,1'"
									/>

									<label
										for="pr6"
										class="custom-pos-label"
									>
										<div class="">
											<span class="uppercase">Non Autorizzo</span>
										</div>
									</label>
								</div>
							</div>
							<label
								class="red"
								v-show="errors.has('agreement3_player')"
							>
								Consenso per finalità di marketing va accettato oppure rifiutato
							</label>
						</div>
					</div>

					<div class="col-md-8">
						Il consenso è facoltativo e può in ogni momento revocare la Sua dichiarazione di consenso alla Società scrivendo al seguente indirizzo e-mail: privacy@heinekenitalia.it
					</div>

					<!-- <div class="col-12 col-md-12">
						<div class="group mt-4 mt-lg-0">

							<div class="form-check ml-1 mt-1">
								<input
									class="form-check-input"
									type="checkbox"
									v-model="agreement1_player"
									id="agreement1_player"
									name="agreement1_player"
									data-vv-as="Accetto i termini della informativa"
									v-validate="{ required: true }"
									:class="{ 'is-invalid': errors.has('agreement1_player') }"
								/>

								<label
									class="form-check-label Regular"
									for="agreement1_player"
								>
									Dichiaro di aver preso visione del
									<a
										:href="regolamentoPolicy"
										target="_blank"
										class="black underline"
									>Regolamento</a>
									e dell’<a
										class="black underline"
										:href="privacyPolicy"
										target="_blank"
									>Informativa sulla privacy</a>
									e acconsento al trattamento dei miei dati personali secondo
									quanto stabilito dal regolamento europeo per la protezione dei
									dati personali n. 679/2016 GDPR
								</label>
								<div
									v-if="errors.has('agreement1_player')"
									class="invalid-feedback"
								>
									{{ errors.first("agreement1_player") }}
								</div>
							</div>
						</div>
					</div> -->

					<div
						v-show="adult2"
						class="col-md-12 center mt-3"
					>
						<button
							class="btn btn-primary-inv"
							type="submit"
						>
							REGISTRATI

						</button>
					</div>
				</div>
			</form>

			<div
				v-if="authStatus == 'success'"
				class="container"
			>
				<div class="row align-items-center py-5">
					<div class="col-12 col-md-8 mx-auto">
						<div class="center">

							<h3 class="  Bold py-2 color-2 pt-5">
								Conferma la tua email </h3>

							<h4 class="mt-4">
								Ti abbiamo inviato una mail all’indirizzo che ci hai indicato. <br>
								<b class="color-2"> Controlla la tua casella </b>di posta,
								anche nella cartella <b class="color-2">spam</b>.
							</h4>
							<h4 class="mt-4">
								<b class="color-2"> Clicca sul </b>link che troverai
								all’interno del messaggio per confermare la tua registrazione e
								torna sul sito per giocare.
							</h4>

							<div class="mt-5">
								<router-link
									tag="button"
									class="btn btn-primary-inv uppercase"
									to="/login"
								>
									accedi
								</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>



<script>
	import { AUTH_REGISTRATION } from 'actions/auth';
	import { mapGetters, mapState } from 'vuex';
	import axios from 'axios';
	import Datepicker from 'vuejs-datepicker';
	import { it } from 'vuejs-datepicker/dist/locale';
	const moment = require('moment');

	import { checkUniqueMixin } from '../../mixins/checkUniqueMixin';
	import { locationMixin } from '../../mixins/locationMixin';
	import { toDateMixin } from '../../mixins/toDateMixin';
	import { sharedEnvMixin } from '../../mixins/sharedEnvMixin';
	import { gtagMixin } from '../../mixins/gtagMixin';
	import { popupConfigurationMixin } from '../../mixins/popupConfigurationMixin';

	export default {
		components: {
			Datepicker,
		},
		name: 'registration',
		mixins: [
			checkUniqueMixin,
			locationMixin,
			toDateMixin,
			sharedEnvMixin,
			gtagMixin,
			popupConfigurationMixin,
		],
		data() {
			return {
				moment: moment,

				birth_date_player: '',
				username_player: '',
				confirm_username: '',
				password_player: '',
				confirm_password: '',
				first_name_player: '',
				last_name_player: '',
				address_player: '',
				civic_number_player: '',
				province_player: '',
				zip_player: '',
				phone_player: '',
				agreement1_player: '',
				agreement2_player: '',
				agreement3_player: '',
				agreement4_player: '',
				gender_player: '',
				txt1_player: '',

				adult2: true,
				registerPage: false,
				colorType: '',
				colorType2: '',

				disabledDates: {
					to: '',
					from: '',
				},
				disabledBirthdays: {
					to: '',
					from: '',
				},
				openDate: new Date(),
				disabledDatesStart: {},
			};
		},

		methods: {
			addRelayTags() {
				let data = {
					brand: process.env.VUE_APP_RELAY_NAME,
					timeStamp: +new Date(),
					url: location.href,
					'referrer-url': document.referrer,
					userAgent: window.navigator.userAgent,
					'Contest Consent': 'Y',
					'Marketing Consent': this.agreement1_player ? 'Y' : 'N',
					'Profiling Consent': this.agreement2_player ? 'Y' : 'N',
					'Third Party Consent': this.agreement3_player ? 'Y' : 'N',
				};

				_st('addTagProperties', data);

				let localData = {
					email: this.username_player,
					name: this.first_name_player,
					lastname: this.last_name_player,
				};

				_st('addLocalTagProperties', localData);
				_st('publishEvent', 'submit', 'Account');
				_st('publishEvent', 'consent', 'setConsent');
				_st('loadTags');
			},

			showPopUp() {
				this.popupErrorText(
					'',
					'',
					"<h4 class='Regular p-4'>Dal numero di cellulare registrato potrai partecipare anche tramite <b>WhatsApp®</b> inviando la tua prova d'acquisto al numero <b>3917054053</b></h4>",
					'',
					''
				);
			},

			showPdv() {
				var pdv = this.pdv;
				pdv.sort((a, b) => a[1].localeCompare(b[1]));
				var text = '';
				for (var x in pdv) {
					text +=
						'<p class="text-left"> <b class="medium">' +
						pdv[x][1] +
						'</b> - ' +
						pdv[x][0] +
						' </p> ';
				}

				this.$swal({
					type: '',
					title: '<strong class="modalT danger">Punti vendita.</strong>',
					html: '<div class="pdvContainer">' + text + '</div>',
					confirmButtonText: 'CHIUDI',
					confirmButton: 'closeProductsModal',

					background: 'rgb(255, 255, 255)',
				});
			},
			registerPagefun() {
				var _vue = this;
				_vue.registerPage = true;

				this.$router.push({ query: { type: this.colorType, viewform: 1 } });
			},
			registration: function (e) {
				//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
				//PER CHIAMARE PASSARE I NOME DEI CAMPI SUL DB, PER PASSARE DEI PARAMETRI NEL DB CHE NON SERVONO AI FINI DELL'INSERIMENTO/////
				//MA COME CONTROLLO NEL BACK E' SUFFICIENTE ANDARE AD INSERIRE NELLA VARIABILE "NOPASS" DEL CONFIG I CAMPI DA NON CONSIDERARE/
				//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

				let data = this.$encryptByAES({
					player: {
						username_player: this.username_player || '',
						password_player: this.password_player,
						first_name_player: this.first_name_player || '',
						last_name_player: this.last_name_player || '',
						birth_date_player: this.birth_date_player
							? moment(this.birth_date_player).format('YYYY-MM-DD')
							: '',
						address_player: this.address_player || '',
						civic_number_player: this.civic_number_player || '',
						province_player: this.province_player || '',
						zip_player: this.zip_player || '',
						phone_player: '39' + this.phone_player || '',
						email_player: this.username_player || '',
						agreement1_player: this.agreement1_player || 0,
						agreement2_player: this.agreement2_player || 0,
						agreement3_player: this.agreement3_player || 0,
						agreement4_player: this.agreement4_player || 0,
						agreement5_player: this.agreement5_player || 0,

						confirmed_player: 0,
						txt1_player: this.txt1_player || '',
						gender_player: this.gender_player || '',
					},
				});

				this.$callLog('registration', data);

				var itGood = false;
				this.$validator.validate().then((valid) => {
					if (valid && !this.existEmail && !this.existPhone) {
						this.$store.dispatch(AUTH_REGISTRATION, data).then(() => {
							this.scrollToTop();

							this.addRelayTags();

							this.gtagCheck(
								'registration',
								this.username_player,
								'success',
								'success'
							);
						});
					} else {
						this.$scrollTo('#' + this.errors.items[0].field, 700, {
							offset: -170,
						});
					}
				});
			},

			calcNewStartDate: function () {
				this.openDate = new Date(
					moment().format('YYYY') - 18,
					moment().format('MM') - 1,
					moment().format('DD')
				);
				var newStartDate = new Date(1900, 0, 1);
				var now = new Date(
					moment().format('YYYY') - 18,
					moment().format('MM') - 1,
					moment().format('DD')
				);
				this.disabledDatesStart = {
					to: newStartDate, // Disable all dates up to specific date
					from: now, // Disable all dates after specific date
				};
			},
			scrollToTop: function () {
				var _vue = this;
				setTimeout(function () {
					_vue.$scrollTo('.main', 700, { offset: -2000 });
				}, 100);
			},
		},
		watch: {
			agreement1_player(val) {},

			phone_player: function (val) {
				if (val) {
					this.phone_player = val.replace(/\D+/g, '');
				}
			},
			first_name_player: function (val) {
				if (val) {
					this.first_name_player = val.replace(/\d+/g, '');
					this.first_name_player = this.first_name_player.replace(
						/[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi,
						''
					);
					this.first_name_player =
						this.first_name_player.charAt(0).toUpperCase() +
						this.first_name_player.slice(1);
				}
			},
			txt1_player: function (val) {
				if (val < 0) {
					this.txt1_player = val.replace(val, 0);
				}
			},
			cf: function (val) {
				if (val) {
					this.cf = this.cf.replace(
						/[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi,
						''
					);
					this.cf = this.cf.toUpperCase();
				}
			},
			last_name_player: function (val) {
				if (val) {
					this.last_name_player = val.replace(/\d+/g, '');
					this.last_name_player = this.last_name_player.replace(
						/[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi,
						''
					);
					this.last_name_player =
						this.last_name_player.charAt(0).toUpperCase() +
						this.last_name_player.slice(1);
				}
			},
		},
		created: function () {
			this.$validator.extend('notZeros', {
				getMessage: (field) =>
					' Il campo Numero di telefono non ha un formato valido.',
				validate: (value) => {
					// value must be > zero
					if (
						value > 1000000 &&
						value.length > 1 &&
						value != 30000000 &&
						value != 300000000 &&
						value != 3000000000 &&
						value != 30000000000
					)
						return true;
					return false;
				},
			});

			this.colorType = this.$route.query.type;

			if (this.$route.query.viewform) {
				this.registerPage = true;
			}
		},
		mounted: function () {
			// this.scrollToTop();
			(this.disabledDates = {
				to: this.calcToDate(), // Disable all dates up to specific date
				from: this.calcFromDate(), // Disable all dates after specific date
			}),
				(this.disabledBirthdays = {
					from: this.calcToDate18(), // Disable all dates after specific date
				});

			this.$track('disabledDates', this.disabledDates);

			this.calcNewStartDate();
			var _vue = this;
			setTimeout(function () {
				_vue.populateProvinces(), (_vue.scrollFinished = true);
			}, 1500);
		},
		computed: {
			...mapGetters([
				'isAuthenticated',
				'loadingState',
				'authStatus',
				'acceptRelay42',
			]),
		},
	};
</script>
<style lang="css" scoped>
</style>

<style lang="scss">
	// @import './src/assets/scss/forms.scss';
</style>
